import React from "react"
import { notification } from "./ContactForm.module.scss"

export const ValidationMessage = ({ meta }) => {
  return meta.touched && meta.error ? (
    <div className={notification}>{meta.error}</div>
  ) : null
}
